"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var Grid_1 = require("@mui/material/Grid");
var formik_1 = require("formik");
var moment = require("moment");
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var api_service_1 = require("../../../api/api_service");
var button_component_1 = require("../../../common/buttons/button_component");
var switch_button_1 = require("../../../common/buttons/switch_button");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var text_field_with_datepicker_1 = require("../../../common/text_filed/text_field_with_datepicker");
var text_filed_component_1 = require("../../../common/text_filed/text_filed_component");
var route_path_1 = require("../../../constants/route_path");
var schema_1 = require("../../../constants/schema");
require("../fe-page.scss");
var ExitFE = function (_a) {
    var feName = _a.feName, fe_id = _a.fe_id, handleClose = _a.handleClose, inventoryList = _a.inventoryList, user_id = _a.user_id, isAlreadyInacitve = _a.isAlreadyInacitve, minimumDate = _a.minimumDate, maximumDate = _a.maximumDate, initialValues = _a.initialValues;
    var nav = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.appConfigList; }), fe_voluntorily_exit_reasons_list = _b.fe_voluntorily_exit_reasons_list, fe_in_voluntorily_exit_reasons_list = _b.fe_in_voluntorily_exit_reasons_list;
    var _c = React.useState(), inventoryAmount = _c[0], setInventoryAmount = _c[1];
    var _d = React.useState(false), resonForLeaving = _d[0], setReasonForLeaving = _d[1];
    var _e = React.useState(false), inventorystate = _e[0], setInventorystate = _e[1];
    var _f = React.useState(true), voluntarily = _f[0], setVoluntarily = _f[1];
    var _g = React.useState([]), uncheckedValue = _g[0], setUnCheckedValue = _g[1];
    var emptyDetails = '--';
    var handleChange = function (e, value, setFieldValue) {
        var checked = e.target.checked;
        if (!checked) {
            var index = uncheckedValue.indexOf(value);
            uncheckedValue.splice(index, 1);
            setInventorystate(true);
        }
        else if (checked && uncheckedValue.indexOf(value) == -1) {
            uncheckedValue.push(parseInt(value));
            setUnCheckedValue(uncheckedValue);
            if (uncheckedValue.length === inventoryList.length) {
                setInventorystate(false);
                setInventoryAmount();
            }
        }
    };
    var formSubmitHandler = function (values) {
        var payload = {
            user_id: parseInt(user_id),
            exit_type: values.exit_type,
            inventory_ids: uncheckedValue,
            exit_date: moment(values.fromDate).format('YYYY-MM-DD'),
            inventory_amount: inventoryAmount ? parseInt(inventoryAmount) : null,
            reason_type: voluntarily ? 'Voluntarily' : 'Involuntarily'
        };
        if (values.reason.label == "Others") {
            payload['reason'] = values.comments;
        }
        else {
            payload['reason'] = values.reason.label;
        }
        api_service_1.api_service
            .put({
            endPoint: api_service_1.api_service.api_urls.USER_EXIT,
            payLoad: payload,
            domain: process.env.VENDOR_BASE_URL,
        })
            .then(function (res) {
            if (res.status === 200) {
                react_hot_toast_1.default.success(res.data.message);
                handleClose();
                nav("/".concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.feExisted));
            }
            else {
                react_hot_toast_1.default.error(res.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.data.errors);
        });
    };
    var schemaValidation = function () {
        if (inventorystate) {
            return schema_1.schemas.FE_ExitAmounSchemat(minimumDate);
        }
        return schema_1.schemas.FE_ExitSchema(minimumDate);
    };
    React.useEffect(function () {
        if (initialValues.selectedInventoryList.length > 0) {
            setUnCheckedValue(__spreadArray([], initialValues.selectedInventoryList, true));
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: "modal-header header-wrapper" },
            React.createElement("h2", { className: "heading" },
                "Are you sure you want to exit",
                feName
                    ? feName.substring(0, 20) + "".concat(feName.length >= 20 ? '...' : '', "-")
                    : emptyDetails,
                fe_id ? fe_id : emptyDetails,
                " ?"),
            React.createElement("p", { className: "sub-heading" }, "If you want to exit FE, please provide below details")),
        React.createElement(formik_1.Formik, { validateOnBlur: false, enableReinitialize: true, initialValues: __assign({}, initialValues), validationSchema: schemaValidation(), onSubmit: function (values, _a) {
                var resetForm = _a.resetForm;
                formSubmitHandler(values);
            } }, function (_a) {
            var errors = _a.errors, touched = _a.touched, values = _a.values, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched;
            return (React.createElement(formik_1.Form, { className: "input-fileds-wrapper" },
                React.createElement("div", { className: 'modal-body overflow' },
                    React.createElement(Grid_1.default, { container: true, columns: { xs: 12 }, columnSpacing: 3 },
                        React.createElement(Grid_1.default, { item: true, xs: 12 },
                            React.createElement("div", { className: "radio-btn-wrapper green-tick column-type-radios" },
                                React.createElement(material_1.FormLabel, { className: "radio-btn-label" }, "Reason Type"),
                                React.createElement(material_1.RadioGroup, { row: true, name: "handoverdone", key: Math.random().toString(), defaultValue: voluntarily, onChange: function () {
                                        setFieldValue('reason', null);
                                        setVoluntarily(!voluntarily);
                                        setReasonForLeaving(false);
                                    } },
                                    React.createElement(material_1.FormControlLabel, { value: true, control: React.createElement(material_1.Radio, null), label: "Voluntarily" }),
                                    React.createElement(material_1.FormControlLabel, { value: false, control: React.createElement(material_1.Radio, null), label: "Involuntarily" })))),
                        React.createElement(Grid_1.default, { item: true, xs: 6 },
                            React.createElement(drop_down_component_1.default, { required: true, name: "selectedExit", placeholder: "Reason for leaving", dropDownList: voluntarily ? fe_voluntorily_exit_reasons_list ? fe_voluntorily_exit_reasons_list : [] : fe_in_voluntorily_exit_reasons_list ? fe_in_voluntorily_exit_reasons_list : [], onChange: function (val) {
                                    if (val.label == 'Others') {
                                        setFieldValue('comments', '');
                                        setReasonForLeaving(true);
                                    }
                                    else {
                                        setReasonForLeaving(false);
                                    }
                                    setFieldValue('reason', val);
                                    setFieldTouched('reason', true);
                                }, value: values.reason }),
                            errors['reason'] && touched['reason'] ? (React.createElement("div", { className: "error" }, errors['reason'])) : null),
                        React.createElement(Grid_1.default, { item: true, xs: 6 },
                            React.createElement(text_field_with_datepicker_1.default, { required: true, minDate: moment(minimumDate).subtract(7, 'days').format('YYYY-MM-DD'), maxDate: minimumDate, label: 'Last Date Of Working', onChange: function (e) {
                                    setFieldValue('fromDate', e);
                                    setFieldTouched('fromDate', true);
                                }, name: "fromDate", value: values.fromDate }),
                            errors['fromDate'] && touched['fromDate'] ? (React.createElement("div", { className: "error" }, errors['fromDate'])) : null),
                        React.createElement(Grid_1.default, { item: true, xs: 12 },
                            React.createElement("p", { className: "sub-heading modal-sub-heaidng" }, "Please collect the below inventory that assigned to FE"),
                            React.createElement("div", { className: "switch-group switch-scroll" }, inventoryList.map(function (inventory) {
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(switch_button_1.default, { swicthLabel: inventory.inventory_name, defaultChecked: true, value: inventory.inventory_id, key: inventory.inventory_id, name: inventory.inventory_name, onChangeHandler: function (e) {
                                            return handleChange(e, inventory.inventory_id, setFieldValue);
                                        } })));
                            })),
                            errors['selectedInventoryList'] &&
                                touched['selectedInventoryList'] ? (React.createElement("div", { className: "error" }, errors['selectedInventoryList'])) : null),
                        inventorystate &&
                            React.createElement(Grid_1.default, { item: true, xs: 12 },
                                React.createElement(text_filed_component_1.default, { label: "Amount", required: true, name: "inventory_amount", onKeyPress: function (e) {
                                        if (new RegExp(/^[0-9]+$/).test(e.key)) {
                                        }
                                        else {
                                            e.preventDefault();
                                        }
                                    }, onChange: function (val) {
                                        setInventoryAmount(val);
                                        setFieldValue('inventory_amount', val);
                                        setFieldTouched('inventory_amount', true);
                                    }, value: inventoryAmount }),
                                errors['inventory_amount'] &&
                                    touched['inventory_amount'] ? (React.createElement("div", { className: "error" }, errors['inventory_amount'])) : null),
                        resonForLeaving &&
                            React.createElement(Grid_1.default, { item: true, xs: 12 },
                                React.createElement(text_filed_component_1.default, { label: "Other Comments", required: true, name: "comments", onChange: function (val) {
                                        setFieldValue('comments', val);
                                        setFieldTouched('comments', true);
                                    }, value: values.comments }),
                                errors['comments'] && touched['comments'] ? (React.createElement("div", { className: "error" }, errors['comments'])) : null))),
                React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                    React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", onClickHandler: handleClose }),
                    React.createElement(button_component_1.default, { type: "submit", buttonName: "Submit", color: "yellow" }))));
        })));
};
exports.default = ExitFE;
